import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiCommonService } from '@api-services/api-common.service';
import { LEGAL_API_ROUTE_BASE, LEGAL_COMPANY_API_ROUTE_BASE } from '@constants/api-routes.constant';
import { ApiAlertError } from '@decorators/api-alert-error';

import { InpiDepositDeclaration } from '../../creation/creation-core/models/inpi-deposit-declaration';
import { FormalitySupervisorEnum } from '../enums/formality-supervisor.enum';
import { CreationFormality, CreationFormalityJson } from '../models/creation-formality';
import { CreationFormalityAbandon } from '../models/creation-formality-abandon';

/**
 * CreationFormality Service.
 */
@Injectable({
  providedIn: 'root'
})
export class CreationFormalityApiService extends ApiCommonService<CreationFormality> {
  resourceUrl = `${LEGAL_COMPANY_API_ROUTE_BASE}/formalities`;
  singleResourceUrl = `${LEGAL_COMPANY_API_ROUTE_BASE}/formality`;
  createFormalityResourceUrl = `${LEGAL_API_ROUTE_BASE}/formality_creation/companies`;

  @ApiAlertError()
  getCreationFormality(formalityId: number): Observable<CreationFormality> {
    return this.http
      .get(`${this.singleResourceUrl}/${formalityId}`)
      .pipe(map((formalityJson: CreationFormalityJson) => CreationFormality.fromJson(formalityJson)));
  }

  @ApiAlertError()
  createCreationFormalityFromCompany(
    companyId: number,
    formalitySupervisor: FormalitySupervisorEnum
  ): Observable<CreationFormality> {
    const body = {
      formality_supervisor: formalitySupervisor
    };

    return this.http
      .post(`${this.createFormalityResourceUrl}/${companyId}`, body)
      .pipe(map((formalityJson: CreationFormalityJson) => CreationFormality.fromJson(formalityJson)));
  }

  @ApiAlertError()
  postDeposit(formalityId: number, inpiDepositDeclaration: InpiDepositDeclaration): Observable<unknown> {
    return this.http.post(
      `${this.singleResourceUrl}/${formalityId}/company_creation_request_deposit`,
      InpiDepositDeclaration.toJson(inpiDepositDeclaration)
    );
  }

  @ApiAlertError()
  abandonFormality(
    formalityId: number,
    creationFormalityAbandon: CreationFormalityAbandon
  ): Observable<CreationFormality> {
    return this.http
      .post(
        `${this.singleResourceUrl}/${formalityId}/abandon`,
        CreationFormalityAbandon.toJson(creationFormalityAbandon)
      )
      .pipe(map((formalityJson: CreationFormalityJson) => CreationFormality.fromJson(formalityJson)));
  }

  fromJson(json: CreationFormalityJson): CreationFormality {
    return CreationFormality.fromJson(json);
  }

  toJson(model: CreationFormality): CreationFormalityJson {
    return CreationFormality.toJson(model);
  }
}
